/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_Q2Inputs */

const es_marketplace_seo_spain_faq_q2 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo alquilar un barco sin licencia?`)
};

const gl_marketplace_seo_spain_faq_q2 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podo aluguer un barco sen licenza?`)
};

const en_marketplace_seo_spain_faq_q2 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I rent a boat without a licence?`)
};

/**
* | output |
* | --- |
* | "Can I rent a boat without a licence?" |
*
* @param {Marketplace_Seo_Spain_Faq_Q2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_q2 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_Q2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_Q2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_q2(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_q2(inputs)
	return es_marketplace_seo_spain_faq_q2(inputs)
});